// src/components/header/header.component.jsx
import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { auth } from "../../firebase/firebase.utils.js";
import { ReactComponent as Logo } from "../../assets/crown.svg";
import CartIcon from "../cart-icon/cart-icon.component";
import CartDropdown from "../cart-dropdown/cart-dropdown.component.jsx";
import { selectCartHidden } from "../../redux/cart/cart.selectors.js";
import { selectCurrentUser } from "../../redux/user/user.selector.js";

import "./header.styles.scss";

const Header = ({ currentUser, hidden }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const whatsappLink = "https://wa.me/923224314712";

  const isActive = (path) => location.pathname === path;

  const navItems = [
    { label: "Home", path: "/" },
    { label: "Men Wigs", path: "/men-wigs" },
    { label: "Lady Hair", path: "/lady-hair" },
    { label: "New Arrivals", path: "/new-arrivals" },
    { label: "Accessories", path: "/accessories" },
    { label: "Hair Transplant", path: "/hair-transplant" },
    { label: "Hair Centers", path: "/hair-centers" },
    { label: "Articles", path: "/articles" },
    { label: "Track Order", path: "/track-order" },
    { label: "Staff Login", path: "/admin-orders" },
  ];

  return (
    <div className="header">
      <div className="header-top">
        {/* ===== LOGO ===== */}
        <Link className="logo-container" to="/">
          <div className="logo-icon">
            <Logo />
          </div>
          <div className="logo-text">
            <span className="brand-name">CRISPY HAIR SOLUTION<span></span></span>
            <span className="brand-tagline">Private Limted</span>
          </div>
        </Link>

        {/* ===== UTILITIES ===== */}
        <div className="header-utilities">
          <a className="whatsapp-btn" href={whatsappLink} target="_blank" rel="noopener noreferrer">
            📞
          </a>

          {currentUser ? (
            <div className="auth-btn" onClick={() => auth.signOut()}>
              Sign Out
            </div>
          ) : (
            <Link className="auth-btn" to="/signin">
              Sign In
            </Link>
          )}

          <div className="cart-wrapper">
            <CartIcon />
          </div>

          <div className={`menu-toggle ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>

      {/* ===== BOTTOM NAV ===== */}
      <div className={`header-bottom ${menuOpen ? 'open' : ''}`}>
        <div className="nav-container">
          {navItems.map((item) => (
            <Link
              key={item.label}
              className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
              to={item.path}
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </Link>
          ))}
        </div>
      </div>

      {hidden ? null : <CartDropdown />}
    </div>
  );
};

const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
  hidden: selectCartHidden,
});

export default connect(mapStateToProps)(Header);